module.exports = require("/Users/pranavkumar/github/barry-long-website/src/state/createStore")